import './CapturedConfirmation.css';

export interface CapturedConfirmationProps {
  /** What record/field this touched, e.g. "Riverdale — due date". */
  title: string;
  /** The prior value, if this changed something rather than creating it. */
  before?: string;
  /** The value now on record. */
  after: string;
  onUndo: () => void;
}

// Trust-posture primitive (4) — after an approval lands, show exactly what
// changed (a diff, not a vague "saved") and leave a way back out.
export function CapturedConfirmation({ title, before, after, onUndo }: CapturedConfirmationProps) {
  return (
    <div class="captured-confirmation">
      <div class="captured-confirmation__title">{title}</div>
      <div class="captured-confirmation__diff">
        {before ? <span class="captured-confirmation__before">{before}</span> : null}
        <span class="captured-confirmation__after">{after}</span>
      </div>
      <button type="button" class="captured-confirmation__undo" onClick={onUndo}>
        Undo
      </button>
    </div>
  );
}
